import React, {Component} from "react";



import {getSize, CCUtils,CCCounterItem , strings, CCHB, CCButton} from './../../cc-imports'
import PropTypes from 'prop-types'

class CCDailyBonusCounter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            date : undefined
        }
    }

    static propTypes = {
        textStyle : PropTypes.object,
        onClaimPressed : PropTypes.func,
        date : PropTypes.string,
        style : PropTypes.object
    }
    static defaultProps = {
        textStyle : {fontSize : 15},
        onClaimPressed: ()=>{},
        date : undefined,
        style : {}
    }

    componentDidMount() {
        const {date} = this.props;
        this.setState({date : date}, ()=>{
            this.setInterval(
                () => {
                    const {date} = this.state;
                    this.setState(CCUtils.getDateDiff(new Date(date), new Date()));
                },
                1000
            );
            this.setImmediate(
                () => {
                    const {date} = this.state;
                    this.setState(CCUtils.getDateDiff(new Date(date), new Date()));
                },
                1000
            );
        })
    }

    componentWillReceiveProps(nextProps){
        if(new Date(nextProps.date)!=new Date(this.props.date)){
            this.setState({date : nextProps.date});
        }
    }


    render() {
        const { hours, minutes, seconds} = this.state;
        const {style, textStyle, date, onClaimPressed} = this.props;
        const sSize = getSize();
        var now = Date.now();
        var d= new Date(date);
        return (
            <div style={[{justifyContent:'center', alignItems:'center'}, style]}>

            </div>
        );
    }
}


export default CCDailyBonusCounter


// WEBPACK FOOTER //
// ./src/app/components/CCDailyBonusCounter/CCDailyBonusCounter.js